import { preferencesAxios } from "@phc/common/gen/preferencesApiMutator"
import { threatAnalyticsAxios } from "@phc/common/gen/threatAnalyticsApiMutator"
import { useEffect } from "react"
import { chatAxios, aiServiceAxios } from "./aiService"
import useAuth from "./auth"

const authenticatedInstances = [
  chatAxios,
  aiServiceAxios,
  preferencesAxios,
  threatAnalyticsAxios,
]

/**
 * This hook adds an auth interceptor to multiple axios instances to inject the
 * current provider's access token (Auth0 or Keycloak, depending on the active
 * provider).  It should be mounted once at the top level of the application
 * (e.g., in App.tsx or AppProviders.tsx).
 */
export const useAxiosAuthInterceptor = () => {
  const { getAccessTokenSilently } = useAuth()

  useEffect(() => {
    // Attach interceptor to all instances
    const interceptorIds = authenticatedInstances.map(instance => {
      return instance.interceptors.request.use(async config => {
        try {
          const token = await getAccessTokenSilently()
          if (token) {
            config.headers.Authorization = `Bearer ${token}`
          }
        } catch (error) {
          console.error("Failed to attach auth token", error)
        }
        return config
      })
    })

    // Cleanup: Eject all interceptors on unmount or when dependencies change
    return () => {
      authenticatedInstances.forEach((instance, index) => {
        interceptorIds[index] &&
          instance.interceptors.request.eject(interceptorIds[index])
      })
    }
  }, [getAccessTokenSilently])
}
